import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "./themes/classes.scss";
import React from "react";
import "./custom.css";
import { Route, Routes } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
import SSRProvider from "react-bootstrap/SSRProvider";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import { LoadPanel } from "devextreme-react/load-panel";
import AppRoutes from "./AppRoutes";
import Login from "./Login";
import SidePanelDrawer from "./components/SidePanelDrawer/SidePanelDrawer";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import "./App.scss";
import Api from "./api";
import { UserProvider, useUser } from "./contexts/UserContext";

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {
  console.log(`App running in ${process.env.NODE_ENV} mode.`);
  const { userRoles } = useUser();
  return (
    <div className="App">
      <SSRProvider>
        <ThemeProvider
          breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
          minBreakpoint="xxs"
        >
          <AuthenticatedTemplate>
            {userRoles.length > 0 ? (
              <div className="page-content">
                <div className="side-panel-wrapper">
                  <SidePanelDrawer>
                    <div className="partner-portal-body w-100">
                      <Header />
                      <div id="app-router" className="partner-portal-content">
                        <Routes>
                          {AppRoutes.map(({ key, path, element }) => (
                            <Route key={key} path={path} element={element} />
                          ))}
                        </Routes>
                      </div>
                      <Footer />
                    </div>
                  </SidePanelDrawer>
                </div>
              </div>
            ) : (
              <LoadPanel position="center" visible={true} showPane={false} />
            )}
          </AuthenticatedTemplate>
        </ThemeProvider>
      </SSRProvider>
    </div>
  );
};

function App() {
  const backend = new Api();

  return (
    <Login>
      <UserProvider backend={backend}>
        <MainContent />
      </UserProvider>
    </Login>
  );
}
export default App;
